import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Quote, BookOpen, ZoomIn, Play } from 'lucide-react';

import { parseYoutubeUrl } from '../lib/youtube-url';

import { getHostedVideo, getImagePaths, getMemoryText, profilePath } from './memoryUtils';
import { YoutubePoster } from './YoutubeVideo';
import './Memory.css';

export default function Memory({ memory, profileSlug, onImageClick }) {
  const path = `${profilePath(profileSlug)}/vzpominka/${memory.id}`;
  const type = memory.metadata.type;
  const { primaryText, secondaryText } = getMemoryText(memory);
  const images = getImagePaths(memory);
  const hasText = Boolean(primaryText || secondaryText);
  const video = type === 'youtube' && parseYoutubeUrl(memory.metadata.youtubeUrl);
  const hostedVideo = getHostedVideo(memory);
  return (
    <article className={`memory-item memory-item-${type}`}>
      {hostedVideo && (
        <Link to={path} className="memory-hosted-video" aria-label="Otevřít video">
          {hostedVideo.poster && <img src={hostedVideo.poster} alt={secondaryText || 'Video vzpomínky'} loading="lazy" />}
          <span>
            <Play size={30} fill="currentColor" />
          </span>
        </Link>
      )}
      {video && (
        <Link to={path} className="memory-video-link" aria-label="Otevřít video">
          <YoutubePoster video={video} title={secondaryText} />
        </Link>
      )}
      {type === 'image' && (images.reduced || images.original || images.thumbnail) && (
        <button type="button" className="memory-photo-button" onClick={() => onImageClick(memory)} aria-label="Zvětšit fotografii">
          <img src={images.reduced || images.original || images.thumbnail} alt={secondaryText || primaryText || 'Fotografie ze vzpomínek'} className="memory-photo" loading="lazy" decoding="async" />
          <span className="memory-zoom" aria-hidden="true">
            <ZoomIn size={19} />
          </span>
        </button>
      )}
      <Link to={path} className={`memory-card-text${hasText ? '' : ' memory-card-no-text'}`} aria-label="Otevřít vzpomínku">
        {type === 'quotation' && <Quote size={26} className="memory-type-symbol" />}
        {type === 'story' && (
          <span className="memory-kind">
            <BookOpen size={16} /> Příběh
          </span>
        )}
        {secondaryText && <h3 className="memory-secondary-text">{secondaryText}</h3>}
        {primaryText && (type === 'quotation' ? <blockquote className="memory-primary-text">„{primaryText}“</blockquote> : <p className="memory-primary-text">{primaryText}</p>)}
        <footer className="memory-card-footer">
          <span className="memory-author">{memory.author || (type === 'image' ? 'Fotografie' : 'Vzpomínka')}</span>
          <span className="memory-comment-count" title="Komentáře">
            <MessageCircle size={15} />
            <span>{memory.commentCount}</span>
          </span>
        </footer>
      </Link>
    </article>
  );
}
